import { render, staticRenderFns } from "./FormNumero.vue?vue&type=template&id=ba722166&scoped=true"
import script from "./FormNumero.vue?vue&type=script&lang=js"
export * from "./FormNumero.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba722166",
  null
  
)

export default component.exports